import { muiDataGridStarted } from "../apiutils";
import { apiSlice } from "../createApiSlice";

const BATCH_BASE = "/batches";
const buildUrl = (endpoint) => BATCH_BASE + endpoint;

const stockApiSlice =  apiSlice.injectEndpoints({
    endpoints: builder => ({
        getBatches: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'Batch' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getBatches', 'Batch')
        }),
        getOrdersFromBatch: builder.query({
            query: ({ args, invalidate }) => ({
                url: buildUrl(`/orders?page=${args.page}&size=${args.size}`),
                method: 'POST',
                body: args.body,
            }),
            providesTags: () => [{ type: 'BatchOrders' }],
            onQueryStarted: muiDataGridStarted.bind(null, 'getBatches', 'Batch')
        }),
        getBatch: builder.query({
            query: id => buildUrl(`/${id}`),
            providesTags: (result, error, arg) => [{ type: 'Batch', id: arg }]
        }),
        addBatch: builder.mutation({
            query: batchInfo => ({
                url: buildUrl(`/create`),
                method: 'POST',
                body: batchInfo,
            }),
            invalidatesTags: (result, error, arg) => [{type: 'Batch'}, { type: 'Stock' }, { type: 'ProductsSingle'}, { type: 'StockForProduct'}],
        }),
    })
});

export const { 
    useGetBatchesQuery,
    useGetBatchQuery,
    useAddBatchMutation,
    useGetOrdersFromBatchQuery
 } = stockApiSlice;
